@if (systemComponent) {
    <div class="system-component"
         [ngClass]="{ 'system-component-added': isNewlyAdded }">
        @if (systemComponent?.systemDocument) {
            <div class="card card-borderless">
                <div class="card-header p-0">
                    <h2 class="card-title d-flex align-items-center">
                        {{ systemComponent!.name }}
                    </h2>
                    @if (isEditing) {
                        <div class="card-header-buttons">
                            @if (isEditing) {
                                <ng-container class="card-header-buttons">
                                    <adapt-menu [items]="editDocumentMenu"></adapt-menu>
                                </ng-container>
                            }
                        </div>
                    }
                </div>
                <div class="card-body p-0">
                    @switch (systemComponent!.systemDocument!.type) {
                        @case (SystemDocumentType.ExternalLink) {
                            <adapt-system-external-link [component]="systemComponent"></adapt-system-external-link>
                        }
                        @case (SystemDocumentType.Document) {
                            <adapt-select-document [url]="systemComponent!.systemDocument!.url"
                                                   [readOnly]="true"></adapt-select-document>
                        }
                        @default {
                            <div [froalaView]="systemComponent!.systemDocument!.content"></div>
                        }
                    }
                </div>
            </div>
        }
        @if (systemComponent?.systemProcessMap) {
            <adapt-process-steps-card [processMap]="systemComponent!.systemProcessMap"
                                      [title]="systemComponent!.name"
                                      [isEditing]="isEditing"
                                      [systemComponent]="systemComponent"
                                      [mapStackFrames]="processMapState"
                                      (mapStackFramesChange)="processMapStateChange.emit($event)"
                                      (processMapDeleted)="deleteProcessMap(systemComponent)"
                                      (moveComponentClick)="moveSystemComponent($event)"
                                      (copyComponentClick)="copySystemComponent($event)">
            </adapt-process-steps-card>
        }
        @if (systemComponent?.systemDiagram) {
            <adapt-system-diagram [component]="systemComponent!"
                                  [isEditing]="isEditing"
                                  (diagramDeleted)="deleteDiagram(systemComponent)"
                                  (moveComponentClick)="moveSystemComponent($event)"
                                  (copyComponentClick)="copySystemComponent($event)"> </adapt-system-diagram>
        }
    </div>
}
